import React, { useState, useEffect, useMemo, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import ProductPriceLabels from "../printTemplates/ProductPriceLabels";

const PriceTagDialogMulti = ({ printableProducts, setBarcodePage }) => {
  const printRefBarcode = useRef();

  const barcodePagePrint = useReactToPrint({
    content: () => printRefBarcode.current,
    documentTitle: "Barcodes",

    onAfterPrint: () => {
      setBarcodePage(false);
    },
  });

  return (
    <div className="container">
      <div className="shadow p-1 bg-body rounded floating-button-top">
        <button
          className="btn btn-sm btn-info no-print"
          onClick={() => setBarcodePage(false)}
        >
          Back to Edit
        </button>
        <button
          className="ms-2 btn btn-sm btn-success"
          onClick={barcodePagePrint}
        >
          Print Barcodes
        </button>
      </div>

      <div ref={printRefBarcode}>
        {printableProducts.map((product) => (
          <ProductPriceLabels key={product.id} data={product} />
        ))}
      </div>
    </div>
  );
};

export default PriceTagDialogMulti;
